"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var withCustomError_1 = __importDefault(require("../helpers/withCustomError"));
var min = function (minValue) { return function (value) {
    if (value || value === 0) {
        return value < minValue ? "The value is less than " + minValue : undefined;
    }
    return undefined;
}; };
exports.default = (function (minValue, err) { return withCustomError_1.default(min(minValue))(err); });
//# sourceMappingURL=min.js.map